import React from 'react'

// Components
import { Col } from 'react-bootstrap'
import { Checkbox } from '..'

const CheckboxList = ({ list, selectedList, selectAll = false, expanded = false, selectAllLabel = 'Selecionar todos' }) => {
  const [selectedReportList, setSelectedReportList] = selectedList

  const handleReportForm = (event, report, all = false) => {
    const { checked } = event.target

    if (checked) {
      all
        ? setSelectedReportList(list)
        : setSelectedReportList([...selectedReportList, report])
    } else {
      let newSelectedReportList = []
      !all && (newSelectedReportList = selectedReportList?.filter(item => item.value !== report.value))
      setSelectedReportList(newSelectedReportList)
    }
  }

  return (
    <div className={`checkboxList ${expanded ? 'expanded' : ''}`}>
      {selectAll &&
        <Col xs={expanded ? 12 : 6}>
          <Checkbox
            id={'checkbox-item-all'}
            checked={selectedReportList.length === list.length}
            label={selectAllLabel}
            onChange={(event) => handleReportForm(event, null, true)}
          />
        </Col>}
      {
        list?.map((item, index) => (
          <Col xs={expanded ? 12 : 6} key={index}>
            <Checkbox
              id={'checkbox-'.concat(index)}
              checked={selectedReportList?.map(item => item.value).indexOf(item.value) !== -1}
              label={item.label}
              onChange={(event) => handleReportForm(event, item)}
            />
          </Col>
        )
        )
      }
    </div>
  )
}

export default CheckboxList
